import React, { useState, useContext, useEffect } from "react"
import { Row, Col } from "reactstrap"
import { withRouter } from "react-router"
import Cookies from "universal-cookie"
import { flowRight as compose } from "lodash"
import PropTypes from "prop-types"
import { NotificationContext } from "components/notification"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { userInfo, userRole } from "utils"
import ChatRoomList from "./ChatRoomList"
import MessageListAssistant from "./MessageListAssistant"
import MessageListCustomer from "./MessageListCustomer"
import MessageContext from "../MessageContext"

const MessageContainer = props => {
  const {
    match: { params, url }
  } = props
  const [chatRoomId, setChatRoomId] = useState(params.chatRoomId || "")
  const [chatUser, setChatUser] = useState(
    params.sender === undefined ? "" : params.sender
  )
  const [isInitChat, setIsInitChat] = useState(true)
  const { setSubscribe } = useContext(NotificationContext)
  const { CUSTOMER, CUSTOMER_PURCHASER } = userRole
  const { role } = userInfo()

  useUnSubscribe(setSubscribe)
  useChatRoomId(params.chatRoomId, setChatRoomId)
  useClearUnreads()
  useBread({ to: url, name: "訊息中心" }, true)

  return (
    <MessageContext.Provider
      value={{
        chatRoomId,
        setChatUser,
        setChatRoomId,
        isInitChat,
        setIsInitChat
      }}
    >
      {role === CUSTOMER || role === CUSTOMER_PURCHASER ? (
        <Row>
          <Col>
            <MessageListCustomer />
          </Col>
        </Row>
      ) : (
        <Row>
          <Col sm={4} style={{ height: "calc(100vh - 176px)" }}>
            <ChatRoomList className="unselectable" />
          </Col>
          <Col sm={8}>
            <MessageListAssistant chatUser={chatUser} chatRoomId={chatRoomId} />
          </Col>
        </Row>
      )}
    </MessageContext.Provider>
  )
}

const useUnSubscribe = setSubscribe => {
  useEffect(() => {
    setSubscribe(false)

    return () => {
      setSubscribe(true)
    }
  }, [setSubscribe])
}

const useChatRoomId = (chatRoomId, setChatRoomId) => {
  useEffect(() => {
    if (chatRoomId !== "") {
      setChatRoomId(chatRoomId)
    }
  }, [chatRoomId, setChatRoomId])
}

const useClearUnreads = () => {
  useEffect(() => {
    const cookies = new Cookies()
    cookies.remove("unreads")
    cookies.remove("unreadMessages")
  })
}

MessageContainer.propTypes = {
  match: PropTypes.object.isRequired,
  chatRoomId: PropTypes.string
}

export default compose(
  withBreadcrumb,
  withRouter
)(MessageContainer)
